import React from 'react';
import Modal from 'react-modal';
 
const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)',
    background            :  'none',
    overflow              : 'hidden'
  }
};

class CaptureImages extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modalIsOpen: false,
            deleteDisabled: false,
            bigImage: ""
          };

          this.openModal = this.openModal.bind(this);
          this.afterOpenModal = this.afterOpenModal.bind(this);
          this.closeModal = this.closeModal.bind(this);
      }

    componentDidUpdate(prevProps, prevState, snapshot) {
    }

    openModal() {
        this.setState({modalIsOpen: true});
      }
     
      afterOpenModal() {

      }
     
      closeModal() {
        this.setState({modalIsOpen: false});
      }

    render() {
      const { t } = this.props;
        var images = this.props.images.map((value, i) =>{
            let key = "img_"+i;
            var splitString = value.split('/');
            var imageNameSplit = splitString[splitString.length - 1];
            const imageName = imageNameSplit.split("?")[0];
            return (
              <div className="VideoAndName">
                <img className="CaptureImageDisplay"
                key={key}
                src={value}
                onClick={(event) =>{
                    this.onClick(value);
                }}
                alt =""
                />
                <div  className="VideoName">{imageName}</div>
                </div>
            );
          });


        return (
          <div  className="CaptureImagesContainer">
           <div className="ContentTitle"> {t("images")} </div>
            <div  className="ContentOverFlow">{images}</div>
            <Modal
              isOpen={this.state.modalIsOpen}
              onAfterOpen={this.afterOpenModal}
              onRequestClose={this.closeModal}
              style={customStyles}
              contentLabel="Dialog Image"
              appElement={document.getElementById("root")}
            >
              <div className="BigImageDisplayContainer">
                <img
                  className="BigImageDisplay"
                  key="bigimage"
                  src={this.state.bigImage}
                  alt=""
                />
              </div>
              <div className="ModalDialogFooter">

                <div className="ModalButtonWrapper">
                  <button
                    className="ModalButtonStyle"
                    onClick={()=>{this.deleteImage()}}
                    disabled={this.state.deleteDisabled}
                    id="end_id"
                  >
                    {t("delete")}
                  </button>

                  <button
                    className="ModalButtonStyle"
                    onClick={this.closeModal}
                    id="end_id"
                  >
                    {t("close")}
                  </button>
                </div>

              </div>
            </Modal>
          </div>
        );
    }

    deleteImage(){
      this.setState({deleteDisabled : true});
      this.props.deleteImage(this.state.bigImage, ()=>{
        this.setState({deleteDisabled : false});
        this.closeModal();
      });
    }

    onClick(value){
        console.log(JSON.stringify(value));
        this.setState({bigImage: value});
        this.openModal();
    }


}

export default CaptureImages;